import { render, staticRenderFns } from "./AddRecommendation.vue?vue&type=template&id=3f355246&scoped=true&"
import script from "./AddRecommendation.vue?vue&type=script&lang=js&"
export * from "./AddRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f355246",
  null
  
)

export default component.exports